<template>
  <div class="sns-box">
    <div class="sns-divider">
      <span class="line"></span>
      <span class="title">{{ title }}</span>
      <span class="line"></span>
    </div>

    <div class="sns-wrap">
      <button type="button" aria-label="카카오로 로그인" @click="redirectToOAuth('kakao')"><img src="@/assets/images/icon/ico_kakao.png" alt=""></button>
      <button type="button" aria-label="네이버로 로그인" @click="redirectToOAuth('naver')"><img src="@/assets/images/icon/ico_naver.svg" alt=""></button>
      <button type="button" @click="redirectToOAuth('google')"><img :src="googleIconSrc" alt="Google 로그인" /></button>
    </div>
  </div>
</template>

<script setup>
import {useRoute} from 'vue-router';
import {onMounted, ref} from "vue";

import iconGoogle from '@/assets/images/icon/ico_google.svg'
import iconGoogleMobile from '@/assets/images/icon/ico_google_w.svg'

const googleIconSrc = ref(iconGoogle)

onMounted(() => {
  if (window.innerWidth <= 768) {
    googleIconSrc.value = iconGoogleMobile
  }
})

const route = useRoute()
const VUE_APP_API_BASE_URL = process.env.VUE_APP_API_BASE_URL;

const props = defineProps({
  title: {
    type: String,
    default: '간편 로그인'
  },
  buttonType: {
    type: String,
    default: ''
  },
  newMode: {
    type: String,
    default: ''
  },
  newType: {
    type: String,
    default: ''
  },
})

const redirectToOAuth = (provider) => {
  sessionStorage.setItem('oauth2_return_path', route.fullPath)
  if (props.newMode && props.newType) {
    sessionStorage.setItem('oauth2_return_newMode', props.newMode)
    sessionStorage.setItem('oauth2_return_newType', props.newType)
  }
  window.location.href = `${VUE_APP_API_BASE_URL}/oauth2/authorization/${provider}`;

}

</script>

<style scoped>
.sns-box {
  margin-top: 35px;
  width: 100%;
}

.sns-divider {
  display: flex;
  align-items: center;
  gap: 13px;

}

.sns-divider .line {
  color: #999999;
  flex-grow: 1;
  height: 1px;
  background-color: #ccc;
  min-width: 50px; /* ✅ 최소 너비 설정 */
}

.sns-divider .title {
  color: #999999;
  font-family: 'SUIT';
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 21px;
}

.sns-box .sns-wrap {
  display: flex;
  margin-top: 14px;
  justify-content: center;
  gap: 12px;
}

@media (max-width: 768px) {
  .sns-box {
    margin-top: 24px;
  }
}
</style>